import React, { useMemo } from "react";
import { personalInfo, experiences, publications } from "../../data/portfolio";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import SectionHeader from "../SectionHeader/SectionHeader";
import { FiMail, FiCalendar, FiBookOpen } from "react-icons/fi";
import { GiTeapotLeaves } from "react-icons/gi";
import "./About.css";

function calcYearsOfExperience(exps) {
  const parseDate = (str) => {
    if (str.toLowerCase().includes("present")) return new Date();
    const [month, year] = str.trim().split(" ");
    const monthMap = {
      Jan: 0,
      Feb: 1,
      Mar: 2,
      Apr: 3,
      May: 4,
      Jun: 5,
      Jul: 6,
      July: 6,
      Aug: 7,
      Sep: 8,
      Oct: 9,
      Nov: 10,
      Dec: 11,
    };
    return new Date(parseInt(year), monthMap[month] || 0);
  };

  let earliest = new Date();
  let latest = new Date(0);

  exps.forEach((exp) => {
    const parts = exp.period.split("–").map((s) => s.trim());
    const start = parseDate(parts[0]);
    const end = parseDate(parts[1]);
    if (start < earliest) earliest = start;
    if (end > latest) latest = end;
  });

  const months =
    (latest.getFullYear() - earliest.getFullYear()) * 12 +
    (latest.getMonth() - earliest.getMonth());
  const years = Math.floor(months / 12);
  const remaining = months % 12;

  if (years < 1) return `${months}mo`;
  if (remaining >= 6) return `${years}.5+`;
  return `${years}+`;
}

function About() {
  const { description, email } = personalInfo;
  const [ref, visible] = useScrollReveal(0.1);

  const expYears = useMemo(() => calcYearsOfExperience(experiences), []);

  const highlights = [
    { icon: FiCalendar, label: "Experience", value: `${expYears} Years` },
    {
      icon: FiBookOpen,
      label: "Publications",
      value: String(publications.length),
    },
    { icon: GiTeapotLeaves, label: "Chai", value: "∞" },
  ];

  return (
    <section className="about section" id="about">
      <div className="container">
        <SectionHeader title="About Me" subtitle="Get to know me better" />

        <div ref={ref} className={`abt ${visible ? "abt--visible" : ""}`}>
          {/* Photo card */}
          <div className="abt__photo-card">
            <div className="abt__photo-wrap">
              <div className="abt__photo-border" />
              <img
                src="/images/viraj.png"
                alt="Viraj Yadav"
                className="abt__photo"
              />
            </div>
            <a href={`mailto:${email}`} className="abt__email-badge">
              <FiMail /> {email}
            </a>
          </div>

          {/* Bio */}
          <div className="abt__bio">
            {description.split("\n").map((para, i) => (
              <p className="abt__bio-text" key={i}>
                {para}
              </p>
            ))}
          </div>

          {/* Highlight stats */}
          {highlights.map((h) => {
            const Icon = h.icon;
            return (
              <div className="abt__stat" key={h.label}>
                <Icon className="abt__stat-icon" />
                <span className="abt__stat-value">{h.value}</span>
                <span className="abt__stat-label">{h.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default About;
